export const HOMES_BANNER_NON_FLASH_SLOT_COUNT = 4
export const HOMES_CROSS_SELL_PROPERTY_TYPES = ['homes_villas', 'apartments']

export function computeHomesCrossSellBannerPosition(
  offerIds: Array<string>,
  isFlash: (id: string) => boolean,
  isResolved: (id: string) => boolean,
  sectionEnd?: number,
): number | undefined {
  let nonFlashSeen = 0
  const end = Math.min(offerIds.length, sectionEnd ?? offerIds.length)

  for (let i = 0; i < end; i++) {
    if (!isResolved(offerIds[i])) return undefined
    if (isFlash(offerIds[i])) continue

    nonFlashSeen += 1
    if (nonFlashSeen === HOMES_BANNER_NON_FLASH_SLOT_COUNT) {
      return i + 1
    }
  }

  if (sectionEnd !== undefined && nonFlashSeen > 0 && end === sectionEnd) {
    return sectionEnd
  }

  return undefined
}

export function getHomesCrossSellBannerVariant(availableFilters: App.OfferListAvailableFilters | undefined): 'urban' | 'leisure' | undefined {
  const homes = availableFilters?.propertyTypes.find(item => item.slug === 'homes_villas')?.count ?? 0
  const apartments = availableFilters?.propertyTypes.find(item => item.slug === 'apartments')?.count ?? 0

  if (homes === 0 && apartments === 0) {
    return undefined
  }

  return apartments >= homes ? 'urban' : 'leisure'
}
